// `/distributors/$id/audit-log` — таб «Audit-log» в карточке тенанта (PA-12,
// D17 §2.3). Layout-route `distributors.$id.tsx` рендерит AdminShell,
// breadcrumb, TabBar и `redirectIfNotPlatformAdmin` (наследуется child'ом
// через TanStack Router `beforeLoad`). Здесь только content через `embedded`
// режим существующего screen'а из PA-16 (с фильтрами actor/action/since/until).

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import {
  DistributorAuditLogTabScreen,
} from '../features/distributors/tabs/DistributorAuditLogTabScreen'

export const Route = createFileRoute('/distributors/$id/audit-log')({
  component: DistributorAuditLogRoute,
})

function DistributorAuditLogRoute() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    return (
      <RequireAuth>
        <div style={{ padding: 24, color: 'var(--color-text-secondary)' }}>
          Некорректный идентификатор дистрибьютора в URL.
        </div>
      </RequireAuth>
    )
  }
  return (
    <RequireAuth>
      <DistributorAuditLogTabScreen distributorId={numericId} embedded />
    </RequireAuth>
  )
}
